@import "@glidejs/glide/src/assets/sass/glide.core";

.kdx-carousel {
    position: relative;

    .kdx-carousel-inner {
        position: relative;
    }

    .glide__slides {
        white-space: normal;
    }

    .control{

        border:none;

        button {
            position: relative;
            width: 100%;
            background: none;
            outline: none;
            box-shadow: none;
            top: 0;
            border: none;


            svg {
                @include svg-format(10px, 20px, rgb(201, 41, 41));
                stroke: rgb(85, 37, 37);
                transition: transform 350ms;
            }

            &:hover {
                svg {
                    transform: scale(1.25);
                }
            }

            &:focus {
                outline: 1px solid #282828;
            }
        }

        &.hidden{
            visibility: hidden;
        }
    }

    .kdx-carousel-card{
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        margin: 40px 20px 85px 20px;
        width: 80%;
        height: auto;
        max-width: 586px;
        padding: 40px 20px 20px 47px;
        border-radius: 5px;
        background-color: white;
        box-shadow: 0px 14px 52px rgba(0, 61, 107, 0.13);

        p{
            color: #444444;
            text-align: left;
            font-size: 16px;
            line-height: 30px;
            font-style: normal;
            font-weight: 300;
        }

        b, strong {
            font-weight: bold;
        }

        h6{
            font-size: 16px;
            margin: 0 0;
            font-weight: 600;
            color: #444444;
        }
      
        small{
            color: #444444;
            font-style: oblique;
            font-weight: lighter;
            font-size: 13px;
        }


        .quote svg {
            position: absolute;
            top: 0;
            transform: translateY(-50%);
            aspect-ratio: 172.7 / 137.2;
            height: 52px;
            fill: $primary;
        }

        .tail svg {
            position: absolute;
            top: 100%;
            left: 0;
            aspect-ratio: 304 / 103.4;
            height: 45px;
            fill: white;
        }
    }


    .glide__slides {
        white-space: normal;
    }

    .control{

        border:none;

        button {
            position: relative;
            width: 100%;
            background: none;
            outline: none;
            box-shadow: none;
            top: 0;
            border: none;


            svg {
                @include svg-format(10px, 20px, rgb(201, 41, 41));
                stroke: rgb(85, 37, 37);
                transition: transform 350ms;
            }

            &:hover {
                svg {
                    transform: scale(1.25);
                }
            }
        }

        &.hidden{
            visibility: hidden;
        }
    }

    .glide__bullets{

        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        .glide__bullet{
            border-radius: 100%;
            padding:0;
            height:8px;
            width:8px;
            border:none;
            background-color: #F8F8F8;
            margin: 0 9.5px;
    
        }
    
        .glide__bullet--active
        {
            background-color: #2D2D2DCC;
        }
    }

    .controls {

        button {
            position: absolute;
            top: 40%;
            left: 0;
            width: 80px;
            height: 100%;
            background: none;
                background-image:    
                    linear-gradient(
                    to right, 
                    rgba(0,0,0,.5), transparent
                    );
                // reset default btn style
                border: none;
                outline: none;
                box-shadow: none;
    
                svg {
                    @include svg-format(30px, 40px, #fff);
                    stroke: #FFF;
                    transition: transform 350ms;
                }
    
                &:hover {
                    svg {
                        @include media-breakpoint-up(xl) {
                            transform: scale(1.25);
                        }
                        @include media-breakpoint-down(xl) {
                            transform: translate(-50%, -50%) scale(1.25);
                        }
                    }
                }

                &:focus { }
        }
    
        [data-glide-dir=">"] {
            left: auto;
            right: 0;

            background-image:
                linear-gradient(
                to right, 
                transparent,  rgba(0,0,0,.5)
            );
            .icon-desktop, .icon-mobile {
                kdx-icon {
                    svg { margin: 0 0 1px 2px; }
                }
            }
        }
        [data-glide-dir="<"] {
            .icon-desktop, .icon-mobile {
                kdx-icon {
                    svg { margin: 0 2px 1px 0; }
                }
            }
        }

    }   

    @include media-breakpoint-down(md) {
        .controls {
            button {
                width: 40px;

                svg {
                    min-width: 15px;
                    max-width: 15px;
                    max-height: 25px;
                }
            }
        }
    }
}

.testimonial{

    h2{
        font-family: "Hind", sans-serif;
        margin-bottom: 1.5rem !important;
    }
    
    .cta-content{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    .kdx-carousel {

        .veiw-port{
            display: flex;
            justify-content: center;
            align-self: center;
            width: 100%;
            height: 100%;
        }


        .controls {
            position: absolute;
            top: 35%;
            width:100%;
            
            button {
                position: absolute;
                background: none;
                background-image:none;
                // reset default btn style
                border: none;
                outline: none;
                box-shadow: none;
    
                svg {
                    @include svg-format(30px, 40px, rgb(0, 0, 0));
                    stroke: rgb(0, 0, 0);
                    transition: transform 350ms;
                }
    
                &:hover {
                    svg {
                        transform: scale(1.25);
                    }
                }

                &:focus {
                    outline: 1px solid #282828;
                    min-height: 50px;
                }
            }
    
            [data-glide-dir=">"] {
                left: auto;
                right: 0;
                background-image: none;
            }
        }
    } 

    .bullets-wrapper{

        display: flex;
        justify-content: center;
        align-items: center;

        .bullet-Arrow{
           *{
                position: static !important;
            }

            &.controls {
                display:flex;
                justify-content: center;
                align-items: center;
                position: relative;

                button {
                    width: 20px;
                    height: 27px;
        
                    svg {
                        @include svg-format(15px, 25px, #495972);
                        stroke:#495972;
                        transition: transform 350ms;
                    }
        
                    &:hover {
                        svg {
                            transform: scale(1.25);
                        }
                    }

                    &:focus {
                        outline: 3px solid #282828;
                        min-height: 0;
                    }
                }

                .glide__bullet{
                    border-radius: 100%;
                    padding:0;
                    height:8px;
                    width:8px;
                    border:none;
                    background-color: #495972;
                    margin: 0 9.5px;
                }
            }
        }

    }
    
    @media (max-width: 1000px){
        margin-top: 3rem;

        [class^=col]{
            display: flex;
            flex-direction: column;
            padding: 0 25px;
        }

        .kdx-carousel-card{
            width: 100%;
            margin-top: 20px;

            .quote svg {
                transform: translateY(-20px);
            }
        }

        .cta-content {
            align-items: center;

            .ctas {
                margin-bottom: 20px;
            }
        }

        .btn{
            width: 100%;
            margin-bottom: 10px;
        }

        h2{
            text-align: center;
        }

        .controls{
            visibility: hidden;
            width: 0px;
        }

        .bullets-wrapper{
            .controls{
                visibility: visible !important;
            }
        }

    }

    @media(max-width: 700px){

        .col-lg-8{

            .kdx-carousel{

                .kdx-carousel-card{
                    height:fit-content;
                    position:relative;
                    left:0;
                    top:auto;
                    padding: 40px 25px 20px 20px;

                    .tail svg {
                        width: 30%;
                        height: unset;
                    }
                }
            }
        }
    }
}
